import { categories } from "@/utils/constants";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Przeglądaj Kategorie Produktów
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Wybierz interesującą Cię kategorię i odkryj setki produktów w arkuszach Kakobuy
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 hover:bg-background-200 rounded-xl border border-background-200/70 transition-all cursor-pointer overflow-hidden"
            >
              <div className="w-full h-28 md:h-32 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Kakobuy ${cat.name} kategoria`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center gap-2 p-3 md:p-3.5">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-accent-500 text-sm`}></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-800 font-medium whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}